module.exports = require("./af.d.ts");